export default __webpack_public_path__ + "static/media/gc-white-green@2x.7c83edc3.png";